export default class AdminAdSpecs {
  constructor(params) {
    this.params = params;
  }

  edit() {
    this.bindSafeAreaFieldsToggle();
  }

  bindSafeAreaFieldsToggle() {
    N2.handle('click', '.js-admin-safe-area-edit-toggle', (evt) => {
      const safeOn = $(evt.currentTarget).is(":checked");

      $('.admin-safe-area-fields').toggle(safeOn);
    });
  }
}
